/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetClaimShares200ResponseDataInner
 */
export interface GetClaimShares200ResponseDataInner {
    /**
     * 
     * @type {number}
     * @memberof GetClaimShares200ResponseDataInner
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof GetClaimShares200ResponseDataInner
     */
    claimId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetClaimShares200ResponseDataInner
     */
    principalType?: string;
    /**
     * 
     * @type {number}
     * @memberof GetClaimShares200ResponseDataInner
     */
    principalId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetClaimShares200ResponseDataInner
     */
    accessLevel?: GetClaimShares200ResponseDataInnerAccessLevelEnum;
    /**
     * 
     * @type {number}
     * @memberof GetClaimShares200ResponseDataInner
     */
    grantedByUserId?: number;
}


/**
 * @export
 */
export const GetClaimShares200ResponseDataInnerAccessLevelEnum = {
    Ro: 'ro',
    Rw: 'rw'
} as const;
export type GetClaimShares200ResponseDataInnerAccessLevelEnum = typeof GetClaimShares200ResponseDataInnerAccessLevelEnum[keyof typeof GetClaimShares200ResponseDataInnerAccessLevelEnum];


/**
 * Check if a given object implements the GetClaimShares200ResponseDataInner interface.
 */
export function instanceOfGetClaimShares200ResponseDataInner(value: object): value is GetClaimShares200ResponseDataInner {
    return true;
}

export function GetClaimShares200ResponseDataInnerFromJSON(json: any): GetClaimShares200ResponseDataInner {
    return GetClaimShares200ResponseDataInnerFromJSONTyped(json, false);
}

export function GetClaimShares200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClaimShares200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'claimId': json['claimId'] == null ? undefined : json['claimId'],
        'principalType': json['principalType'] == null ? undefined : json['principalType'],
        'principalId': json['principalId'] == null ? undefined : json['principalId'],
        'accessLevel': json['accessLevel'] == null ? undefined : json['accessLevel'],
        'grantedByUserId': json['grantedByUserId'] == null ? undefined : json['grantedByUserId'],
    };
}

export function GetClaimShares200ResponseDataInnerToJSON(json: any): GetClaimShares200ResponseDataInner {
    return GetClaimShares200ResponseDataInnerToJSONTyped(json, false);
}

export function GetClaimShares200ResponseDataInnerToJSONTyped(value?: GetClaimShares200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claimId': value['claimId'],
        'principalType': value['principalType'],
        'principalId': value['principalId'],
        'accessLevel': value['accessLevel'],
        'grantedByUserId': value['grantedByUserId'],
    };
}

